exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lte-tabset{margin-bottom:0}.lte-tabset .fa.fa-close{margin-left:5px;width:16px;text-align:center;cursor:pointer}.lte-tabset .fa.fa-close:hover{color:#dd4b39;border:1px solid #dd4b39;border-radius:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6afab827","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tabset/tabset.vue
// module id = 28
// module chunks = 0